/** Convert macro nutrient quantity to grams when unit is g, mg, or µg/mcg; otherwise return quantity as-is. */
export function convertMacroQuantityToGrams(quantity: number, unit: string): number {
  const unitLower = unit?.toLowerCase() || '';

  if (unitLower === 'g') {
    return quantity;
  }
  if (unitLower === 'mg') {
    return quantity / 1000;
  }
  if (unitLower === 'µg' || unitLower === 'ug' || unitLower === 'mcg') {
    return quantity / 1_000_000;
  }

  return quantity;
}
